import GetTaxes from '@/services/users/taxService/GetTaxes';

export default class TaxService {
    static getTaxes(payload) {
        return (new GetTaxes()).handle(payload);
    }
}
